import { useState, useEffect, useRef, useCallback } from 'react';

export function useAutoHideControls(timeout = 5000) {
  const [visible, setVisible] = useState(true);
  const hideTimerRef = useRef(null);

  const showControls = useCallback(() => {
    setVisible(true);
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    hideTimerRef.current = setTimeout(() => setVisible(false), timeout);
  }, [timeout]);

  useEffect(() => {
    window.addEventListener('mousemove', showControls);
    window.addEventListener('touchstart', showControls);
    hideTimerRef.current = setTimeout(() => setVisible(false), timeout);

    return () => {
      window.removeEventListener('mousemove', showControls);
      window.removeEventListener('touchstart', showControls);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    };
  }, [showControls, timeout]);

  return visible;
}
